import { useEffect, useRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { useWebSocketReconnect } from '@/hooks/useWebSocketReconnect';
import { playSound } from '../monitor/hooks/useAlerts';
import chime from '@/assets/sound/preOpBoardSReady.wav';
import { subscribeToPreOpBoardSound } from './preOpBoardSoundSubscription';

// Only Internal screens mount this hook. No-cache live events are independent
// of the board's MDA filter, React batching, and optimistic patient data.
export const usePreOpBoardSound = (enabled: boolean) => {
  const client = useApolloClient();
  const reconnectCount = useWebSocketReconnect();
  const seenEvents = useRef(new Set<string>());

  useEffect(() => {
    if (!enabled) return;
    return subscribeToPreOpBoardSound(client, () => void playSound(chime), seenEvents.current);
  }, [client, enabled, reconnectCount]);
};
